import { Card, CardContent, IconButton, Stack, styled, Typography } from '@mui/material';
import { CARD_DIMENSIONS } from '@/constants/layout';

export const StyledCardContent = styled(CardContent)`
  display: flex;
  flex-direction: column;
  padding: 8px;
  min-height: 90px;
`;

export const ChipsWrapper = styled(Stack)`
  flex-wrap: wrap;
  flex-direction: row;
  gap: 5px;
  margin: 8px 0;
  overflow: hidden;
  max-height: 16px;
  flex-flow: nowrap;
  text-overflow: ellipsis;

  flex: 1 1 100%;
  min-width: 0;
`;

export const MoreButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0;
  margin: 10px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }

  svg {
    height: 16px;
    width: 16px;
  }
`;

export const ShareButton = styled(IconButton)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  color: white;
  background-color: #2196f3;
  padding: 4px;
  margin: 8px;
  pointer-events: none;
  width: 24px;
  height: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  opacity: 1 !important;
  visibility: visible !important;

  svg {
    height: 16px;
    width: 16px;
  }
`;

export const StyledTypography = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 60px;
  min-height: 40px;
`;

export const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>`
  width: 100%;
  height: ${CARD_DIMENSIONS.HEIGHT}px;
  position: relative;
  outline: 1px solid transparent;

  .MuiIconButton-root {
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    visibility: ${({ isActive }) => (isActive ? 'visible' : 'hidden')};
    transition:
      opacity 0.3s ease,
      visibility 0s 0.3s;
  }

  &:hover {
    .MuiIconButton-root {
      opacity: 1;
      visibility: visible;
      transition: opacity 0.3s ease;
    }
  }
`;
